export const environment = {
  production: false,
  apiBaseUrl: "https://app.processeye.wideum.com",
  supervisorApiUrl: "https://magicapi.remoteeye.com",
  predictionMinimumScore: 50,
};
